import { PartagePlusBadge } from 'app/components/partage-plus-badge';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { PlanRecurrenceEnum } from 'app/schemas/plan';
import React from 'react';

export function AnnualPlanCard({ currency, discounted }: { currency: 'CAD' | 'EUR' | 'USD'; discounted: boolean }) {
  const { t } = useScopedTranslation();
  const period = t(`period.${PlanRecurrenceEnum.yearly}`, { ns: 'payment' });
  const renewalPrice = t(`price.${PlanRecurrenceEnum.yearly}.${currency}`, { ns: 'payment' });
  const discountedPrice = t(`loanDiscount.price.${currency}`, { ns: 'payment' });

  return (
    <Column borderRadius="radius.lg" paddingHorizontal="spacing.general.x4" style={{ backgroundColor: '#F3EEF7' }}>
      <Row alignItems="center" gap="spacing.general.x2" paddingVertical="spacing.general.x4">
        <Column flex={1} gap="spacing.general.x1">
          <Row alignItems="center" gap="spacing.general.x2">
            <PartagePlusBadge />
            {discounted ? (
              <Column
                backgroundColor="surface.default"
                borderRadius="radius.full"
                paddingHorizontal="spacing.general.x4"
                paddingVertical="spacing.general.x1"
              >
                <Text color="text.primary" fontSize={12} fontWeight="700" lineHeight={22}>
                  {t('loanDiscount.percentage', { ns: 'payment' })}
                </Text>
              </Column>
            ) : null}
          </Row>
          {discounted ? (
            <>
              <Row alignItems="center" flexWrap="wrap" gap="spacing.general.x1">
                <Text color="text.primary" fontSize={14} lineHeight={22} textDecorationLine="line-through">
                  {renewalPrice}/{period}
                </Text>
                <Text color="text.primary" fontSize={14} fontWeight="700" lineHeight={22}>
                  {discountedPrice}/{period}*
                </Text>
              </Row>
              <Text color="text.primary" fontSize={10} lineHeight={12}>
                {t('loanDiscount.footnote', { ns: 'payment', discountedPrice, renewalPrice })}
              </Text>
            </>
          ) : (
            <Text color="text.primary" fontSize={14} lineHeight={22}>
              {renewalPrice}/{period}
            </Text>
          )}
        </Column>
        <Column
          backgroundColor="surface.brand.default"
          borderRadius="radius.xs"
          paddingHorizontal="spacing.general.x2"
          paddingVertical="spacing.general.x1"
        >
          <Text color="text.inverse.primary" fontSize={12} fontWeight="500" lineHeight={15}>
            {t('popular', { ns: 'payment' })}
          </Text>
        </Column>
      </Row>
    </Column>
  );
}
